import api from "@/api/Axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  result: [],
  industryAndApplicaton: [],
};

export const getSearchedResults = createAsyncThunk(
  "getSearchedResults",
  async (keyword, { rejectWithValue }) => {
    try {
      if (keyword) {
        const response = await api.get(
          `/home/globally-search/?search=${keyword}`
        );
        if (response?.data?.status === 200) {
          return response?.data?.data;
        }
      } else {
        return [];
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const searchByIndustryAndApplication = createAsyncThunk(
  "searchByIndustryAndApplication ",
  async (keyword, { rejectWithValue }) => {
    try {
      if (keyword) {
        const response = await api.get(
          `/product/industry-application-search/?search=${keyword}`
        );
        if (response?.data?.status === 200) {
          return response?.data?.data;
        }
      } else {
        return [];
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const globalSearchSlice = createSlice({
  name: "globalSearch",
  initialState,
  reducers: {},
  extraReducers: {
    [getSearchedResults.pending]: (state) => {
      state.loading = true;
    },
    [getSearchedResults.fulfilled]: (state, action) => {
      state.result = action?.payload;
      state.loading = false;
    },
    [getSearchedResults.rejected]: (state) => {
      state.loading = false;
    },
    [searchByIndustryAndApplication.pending]: (state) => {
      state.loading = true;
    },
    [searchByIndustryAndApplication.fulfilled]: (state, action) => {
      state.industryAndApplicaton = action?.payload;
      state.loading = false;
    },
    [searchByIndustryAndApplication.rejected]: (state) => {
      state.loading = false;
    },
  },
});

export default globalSearchSlice.reducer;
